import { updateReportTypeAction } from "../../../../actions/ReportType/manageReportTypeAction";

async function submit(values, dispatch) {
    await dispatch(updateReportTypeAction(values))
}

export default submit;